import './App.css';

import Admin from './components/Admin/Admin';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import './components/Admin/Customer.css'
import Login from './components/Admin/Pages/Logggging/Login';
import React, { useEffect } from 'react';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import PublicRoute from './components/Auth/PublicRoute';
import { AuthProvider } from './components/Auth/AuthContext';

function App() {
  useEffect(() => {
    // Set the new title here
    document.title = 'Lưu Gia Admin';
  }, []);

  return (
    <AuthProvider>
      <div className="App">
        <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/admin/login" />} />
              <Route 
                path="/admin/login" 
                element={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                } 
              />
              <Route 
                path="/admin/*" 
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                } 
              />
            </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
